import { EventEmitter, Input, Output, Directive } from '@angular/core';
import isEmpty from 'lodash-es/isEmpty';

import { isNullOrUndefined } from '@app/util/util';
import { PropertiesAmplitudeService } from '@app/services/properties-amplitude.service';
import { AlertResponse, AlertSelectParams } from '@shared/widgets/entities/alerts';
import { UserAlertsFacade } from '@user-alerts/store/user-alerts.facade';
import { TriggerAmplitudeService } from '@amplitude/services/trigger-amplitude.service';

@Directive()
export class UserAlertsAbstract {

  @Output() toggleAlertsManagement: EventEmitter<void> = new EventEmitter<void>();

  public notifyAlertCreated: boolean = false;
  public isCreated: boolean = false;
  public showConfirmDeleteAlert: boolean = false;

  private _alertSelected: AlertResponse = null;

  constructor(
    protected userAlertsFacade: UserAlertsFacade,
    protected amplitude: PropertiesAmplitudeService,
    protected triggerAmplitudeService: TriggerAmplitudeService
  ) { }

  get hasAlertSelection(): boolean {
    return !!this.alertSelected && !isEmpty(this.alertSelected);
  }

  get isUpdateForm(): boolean {
    return this.hasAlertSelection && !isNullOrUndefined(this.alertSelected.id);
  }

  public toggleAlertCreated(isCreated: boolean): void {
    this.notifyAlertCreated = !this.notifyAlertCreated;
    this.isCreated = !isNullOrUndefined(isCreated) ? isCreated : true;
  }

  public createAlert(params: AlertSelectParams): void {
    if (this.alertSelected) {
      this.userAlertsFacade.createAlert({
        ...this.alertSelected,
        price_max: params.maxPriceAlert,
        direct_only: params.directOnly ? 1 : 0,
        oneway: this.alertSelected.oneway ? 1 : 0
      });
    }
  }

  public get alertSelected(): AlertResponse {
    return this._alertSelected;
  }

  @Input()
  public set alertSelected(value: AlertResponse) {
    this._alertSelected = value;
  }

}
